import React, { useEffect, useRef, useState } from "react";
import { IoIosPersonAdd } from "react-icons/io";
import { MdDirectionsBus } from "react-icons/md";
import { useAuth } from "../../context/Auth";
import { useGlobalContext } from "../../context/stateContext";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const CashierItemReturn = () => {
  const searchRef = useRef();
  const { requestWithAuth } = useAuth();
  const { activeSession } = useGlobalContext();
  const [drugsDropdown, setDrugsDropdown] = useState(true);
  const [drugs, setDrugs] = useState([]);
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);
  const [selectedDrug, setSelectedDrug] = useState(null);
  const [insertedDrugs, setInsertedDrugs] = useState([]);
  const [drugBatches, setDrugBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [saleData, setSaleData] = useState({
    branch: activeSession?.branch?.id,
  });
  const [recordingSale, setRecordingSale] = useState(false);
  const [totalCost, setTotalCost] = useState(0.0);
  const [quantityRequested, setQuantityRequested] = useState("");

  const updateSaleData = (e) => {
    setSaleData({
      ...saleData,
      [e.target.name]: e.target.value,
    });
  };

  const selectDrug = (drug) => {
    if (parseFloat(drug?.quantity) <= 0) {
      Swal.fire("", "This drug is out of stock", "error");
      return false;
    } else {
      getBatches(drug?.drug?.id);
      setSelectedDrug(drug);
    }
    setDrugsDropdown(false);
    setSearch("");
    setDrugs([]);
  };

  const getDrugs = async (search_query) => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/inventory/branch/${activeSession?.branch?.id}?page=1&pageSize=10000000000000&search=${search_query}`,
        "GET"
      );
      setDrugs(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getBatches = async (drug) => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/inventory/branch/batches/list?page=1&pageSize=100000000000000000000&branch=${activeSession?.branch?.id}&drug=${drug}`,
        "GET"
      );
      setDrugBatches(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
      setLoading(false);
    }
  };

  const recordSales = async (e) => {
    e.preventDefault();
    if (insertedDrugs.length <= 0) {
      return toast.error("Insert at least one drug");
    }
    Swal.fire({
      icon: "question",
      title: "Are you sure you want to record the sale?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setRecordingSale(true);
          const body = JSON.stringify({
            ...saleData,
            branch: activeSession?.branch?.id,
            session: activeSession?.session,
            sale_items: insertedDrugs,
          });

          const data = await requestWithAuth(
            `/inventory/damage/`,
            "POST",
            body,
            {
              "Content-Type": "application/json",
            }
          );

          Swal.fire({
            icon: "success",
            title: "Requested!",
            text: "Damage Recorded Successfully",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          if (error.response.data.error) {
            for (const property in error.response.data.error) {
              toast.error(
                `${property} error: ${error.response.data.error[property]}`
              );
            }
          }
          if (error.response.status === 500) {
            toast.error("Something went wrong!");
          }
        } finally {
          setRecordingSale(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const insertDrug = () => {
    
      if(selectedBatch){
        
        if(parseInt(quantityRequested) > parseInt(selectedBatch?.quantity)){
          return toast.error("Quantity requested is greater than the batch quantity")
        }
      }
    
    if (selectedDrug) {
      if (quantityRequested) {
        const total_cost =
          parseFloat(selectedDrug?.drug?.selling_price) *
          parseFloat(quantityRequested);
        const newInsertedDrugs = [
          ...insertedDrugs,
          {
            drug: selectedDrug?.drug?.id,
            drug_name: selectedDrug?.drug?.name,
            quantity: quantityRequested,
            unit_price: selectedDrug?.drug?.selling_price,
            batch: selectedBatch?.id,
            total_cost: total_cost.toFixed(2),
          },
        ];
        setSelectedDrug({});
        setSelectedBatch({})
        setInsertedDrugs(newInsertedDrugs);
        setQuantityRequested("");

        let total = 0;
        newInsertedDrugs.map((item) => {
          total += parseFloat(item?.total_cost);
        });
        setTotalCost(total.toFixed(2));
      } else {
        toast.error("Please enter the quantity");
      }
    } else {
      toast.error("Select a drug first");
    }
  };

  const removeInsertedDrug = (index) => {
    const newInsertedDrugs = [...insertedDrugs];
    newInsertedDrugs.splice(index, 1);
    setInsertedDrugs(newInsertedDrugs);
    let total = 0;
    newInsertedDrugs.map((item) => {
      total += parseFloat(item?.total_cost);
    });
    setTotalCost(total.toFixed(2));
  };

  useEffect(() => {
    if (search.length >= 2) {
      getDrugs(search);
    }
  }, [search]);

  useEffect(() => {
    searchRef.current.focus();
  }, []);

  return (
    <div className="p-[20px]">
      <div className="grid lg:grid-cols-2 gap-4">
        <form
          onSubmit={(e) => recordSales(e)}
          className="border border-[#ddd] bg-white"
        >
          <div className="p-[20px]">
            <h5 className="text-[17px] font-[500]">Return Item</h5>
          </div>
          <div className="p-[20px] pt-0">
            <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
              <MdDirectionsBus className="text-[12px]" />
              <label htmlFor="item" className="text-[12px] font-[500]">
                Item Details
              </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-3">
              <div className="flex flex-col mb-[20px]">
                <label htmlFor="" className="font-bold">
                  Source Branch:
                </label>
                <input
                  disabled
                  type="text"
                  value={activeSession?.branch?.name}
                  className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                />
              </div>
              
            </div>

            <div>
            <div className="flex flex-col mb-[20px] ">
                <label htmlFor="" className="font-bold">
                  Drug Name:
                </label>
                <div
                  className="relative cursor-pointer border h-[35px] border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  onClick={() => {
                    setDrugsDropdown(!drugsDropdown);
                    searchRef.current.focus();
                  }}
                >
                  {selectedDrug?.drug?.name}
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className={`absolute -bottom-[100px] w-full bg-white left-0 border border-[#ddd] ${
                      drugsDropdown ? "block" : "hidden"
                    }`}
                  >
                    <div className="p-2">
                      <input
                        ref={searchRef}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        type="text"
                        className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px] w-full"
                      />
                    </div>
                    <p className="p-2 text-gray-500">
                      {search?.length < 2 ? (
                        "Please enter at least 2 characters"
                      ) : (
                        <>
                          {loading ? (
                            "Searching..."
                          ) : (
                            <>
                              {drugs?.length > 0 ? (
                                <drug className="max-h-64 overflow-y-scroll absolute bg-white w-full left-0">
                                  {drugs?.map((drug_item) => {
                                    return (
                                      <div
                                        onClick={() => selectDrug(drug_item)}
                                        className="p-2 hover:bg-red-500 hover:text-white"
                                      >
                                        {drug_item?.drug?.name} - Ghc{" "}
                                        {drug_item?.drug?.selling_price}
                                      </div>
                                    );
                                  })}
                                </drug>
                              ) : (
                                "No result found"
                              )}
                            </>
                          )}
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 gap-2">
              
              <div className="flex flex-col mb-[20px]  ">
                <label htmlFor="" className="font-bold">
                  Drug Batch:
                </label>
                <select
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value) {
                      setSelectedBatch(JSON.parse(value)); // Parse only if value is not empty
                    } else {
                      setSelectedBatch(null); // Reset if "Select Batch" is chosen
                    }
                  }}
                  name=""
                  id=""
                  className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                >
                  <option value="">Select Badge</option>
                  {drugBatches?.map((batch, index) => (
                    <option key={index} value={JSON.stringify(batch)}>
                      {batch.batch_number}
                    </option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Quantity:
                  </label>
                  <input
                    type="number"
                    min={0}
                    onChange={(e) => setQuantityRequested(e.target.value)}
                    value={quantityRequested}
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Total:
                  </label>
                  <div className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px] h-[36px] bg-gray-50">
                    {
                      drugBatches?.length > 0 ? <>
                        {selectedBatch?.quantity}
                      </>:<>
                        {selectedDrug?.quantity}
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>

            
            {recordingSale ? (
              <div className="flex gap-2 justify-end items-center  ">
                <div className="flex gap-2 items-center w-max bg-blue-400 text-white px-2 py-1 text-[11px]">
                  <RotatingLines
                    visible={true}
                    height="16"
                    width="16"
                    color="black"
                    strokeColor="white"
                    strokeWidth="5"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />{" "}
                  Recording Return
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-end">
                <div className="flex gap-2 items-center">
                  <div
                    className="bg-blue-500 text-white px-2 py-1 text-[11px] cursor-pointer"
                    onClick={() => insertDrug()}
                  >
                    Insert Drug
                  </div>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 text-[11px]"
                    type="submit"
                  >
                    Record Return
                  </button>
                </div>
              </div>
            )}
          </div>
        </form>
        <div className="bg-white border border-[#ddd]">
          <div className="overflow-x-auto min-h-[0.01%]">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-slate-500">
                  <th className="py-[12px] px-[20px]">ID #</th>
                  <th className="py-[12px] px-[20px]">Drug Name</th>
                  <th className="py-[12px] px-[20px]">Unit Price</th>
                  <th className="py-[12px] px-[20px]">Quantity</th>
                  <th className="py-[12px] px-[20px]">Total Price</th>
                  <th className="py-[12px] px-[20px]">Action</th>
                </tr>
              </thead>
              <tbody>
                {insertedDrugs?.map((drug, index) => (
                  <tr className="border-b border-gray-500" key={index}>
                    <td className="py-[12px] px-[20px] text-center">
                      {drug?.drug}
                    </td>
                    <td className="py-[12px] px-[20px] text-center">
                      {drug?.drug_name}
                    </td>
                    <td className="py-[12px] px-[20px] text-center">
                      {drug?.unit_price}
                    </td>
                    <td className="py-[12px] px-[20px] text-center">
                      {drug?.quantity}
                    </td>
                    <td className="py-[12px] px-[20px] text-center">
                      {drug?.total_cost}
                    </td>
                    <td className="flex items-center justify-center py-[12px]">
                      <div
                        onClick={() => removeInsertedDrug(index)}
                        className="bg-[#F44336] text-[10px] pt-[2px] px-[5px] pb-[1px] text-white cursor-pointer"
                      >
                        REMOVE
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="py-[12px] px-[20px]">Totals:</td>
                  <td className="py-[12px] px-[20px]">{totalCost}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashierItemReturn;
